import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'hybrid-server500',
    templateUrl: './server500.component.html',
    styleUrls: ['./server500.component.scss']
})
export class Server500Component implements OnInit {
    ngOnInit() {
        document.body.classList.add('background--preauth-refresh');
    }
}
